import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {HttpClient}from '@angular/common/http';
import { Csp5020Class } from '../../CSPClass/CSP5020/csp5020-class';
import { environment } from '../../../../../../../src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class Csp5020Service {
     baseUrl: string=  environment.baseUrlCsp + 'CSP5020/';
        constructor(private http:HttpClient) { }

CourseFee(Csp5020Class:Csp5020Class):Observable<any>
{
  return this.http.post<any>(this.baseUrl+'CourseFee',Csp5020Class);
}
  
}
